import { V3Record } from "data/helpers/V3Record.js";

export const ExperiencePackage = V3Record("experiencePackage", {
  experienceId: null,
  createdAt: null,
  packageFileSize: null,
});
